import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { calculateJobTotal } from 'utils';

export interface OpenBankingInfoHook {
  subsidy: number;
  jobPercentage: number;
  example: number;
  showInvalid: boolean;
}

export default function useOpenBankingInfo(): OpenBankingInfoHook {
  const [lineItems] = useWatch({
    name: ['job.job_items'],
  });

  const total = useMemo(() => {
    const totals = calculateJobTotal(lineItems);
    return totals.totalIncVat;
  }, [lineItems]);

  const jobPercentage = useMemo(() => total * 0.01, [total]);

  const subsidy = useMemo(() => Math.min(jobPercentage), [jobPercentage]);

  const example = useMemo(() => total * 0.0175, [total]);

  const showInvalid = useMemo(() => total > 1000000, [total]);

  return {
    subsidy,
    jobPercentage,
    example,
    showInvalid,
  };
}
